import insta from '../../assets/image/About/instagram.png';
import git from '../../assets/image/About/github.png';
import linkedIn from '../../assets/image/About/linkedin.png';
import whatsUp from '../../assets/image/About/whatsapp.png';
let skills = [
    {
      skill: "Javascript",
      percentage: "90%",
    },
    {
      skill: "Typescript",
      percentage: "70%",
    },
    {
      skill: "React Js",
      percentage: "90%",
    },
    {
      skill: "React Native",
      percentage: "80%",
    },
    {
      skill: "Mongo DB",
      percentage: "90%",
    },
    {
      skill: "Express Js",
      percentage: "80%",
    },
    {
      skill: "Node Js",
      percentage: "80%",
    },
    {
      skill: "MUI",
      percentage: "80%",
    },
    {
      skill: "Tailwind",
      percentage: "70%",
    },
    {
      skill: "HTML",
      percentage: "90%",
    },
    {
      skill: "CSS",
      percentage: "90%",
    },
  ];
  let exp_edu = [
    {
      type: "work",
      title: "Full Stack Developer",
      duration: "2022-Present",
      firm: "Bitwit Technologies",
      description:
        "At Bitwit Technologies, I specialize in full-stack development, crafting robust solutions that span front-end and back-end domains, ensuring scalable systems and responsive interfaces.",
      link: "https://bitwittech.com/",
    },
    {
      type: "work",
      title: "Software Engineer Intern",
      duration: "2021-2021",
      firm: "Rampwin Technologies",
      description:
        "As a Software Developer Intern at Rampwin Technologies, I contribute to both product development and service enhancement initiatives.",
      link: "https://www.rampwin.com/",
    },

    {
      type: "work",
      title: "Full Stack Developer",
      duration: "2022-Present",
      firm: "Classbazzar",
      description:
        "At Classbazzar, I manage the full product lifecycle, from ideation to execution, focusing on user-centric design and scalable backend development.",
      link: "https://classbazaar.com/",
    },
    {
      type: "education",
      title: "Bachelor of Computer Applications",
      duration: "2019-2022",
      firm: "Dezyne E'cole College Ajmer",
      description:
        "It a 3yr program for computer enthusiast. So, they can learn about development.",
      link: "https://www.dezyneecole.com/",
    },
  
  ];
let social_links = [
  {
    link : "https://www.instagram.com/yashwant.sahu.3002/",
    img : insta,
    name : 'Instagram'
  },
  {
    link : "https://www.linkedin.com/in/yashwant-sahu-4309b8195/",
    img : linkedIn,
    name : 'LinkedIn'
  },
  {
    link : "https://wa.me/+918302043259",
    img : whatsUp,
    name : 'WhatsApp'
  },
  {
    link : "https://github.com/YASH1730",
    img : git,
    name : 'Git'

  },
]

  export {skills, exp_edu, social_links};